// src/components/products/SubCategoryDescription.jsx
import React from "react";
import ProductContainerImage from "./ProductContainerImage";

const SubCategoryDescription = ({ activeSubCategory, safeText }) => {
  if (
    !activeSubCategory ||
    (!activeSubCategory.description &&
      !activeSubCategory.description_image?.url)
  ) {
    return null;
  }

  const categoryName = safeText(activeSubCategory.name);

  return (
    <article
      className="product-subcategory-intro"
      aria-label={`${categoryName} overview`}
    >
      <p className="product-label mb-3 sm:mb-4">Overview</p>

      <div className="flex flex-col md:flex-row gap-5 sm:gap-7 md:gap-8 items-start">
        {activeSubCategory.description_image?.url && (
          <div className="flex-shrink-0 w-full md:w-auto">
            <ProductContainerImage
              src={activeSubCategory.description_image.url}
              alt={categoryName || "Category illustration"}
              className="pointer-events-none select-none"
            />
          </div>
        )}

        {activeSubCategory.description && (
          <div className="md:flex-1 min-w-0">
            {categoryName && (
              <h2 className="text-lg sm:text-xl md:text-2xl font-bold product-heading mb-3 sm:mb-4 leading-tight">
                {categoryName}
              </h2>
            )}
            <p className="product-detail-content text-base sm:text-lg text-gray-700 whitespace-pre-line">
              {safeText(activeSubCategory.description)}
            </p>
          </div>
        )}
      </div>
    </article>
  );
};

export default SubCategoryDescription;
